import { type DocNode } from '@atlaskit/adf-schema';
import { type Fragment, Node as PMNode, type Schema } from '@atlaskit/editor-prosemirror/model';

export const adfResponseToFragment = ({
	schema,
	adfResponse,
	adfResponseNodeWrappers,
}: {
	adfResponse: DocNode;
	adfResponseNodeWrappers?: string[];
	schema: Schema;
}): Fragment => {
	let fragment = PMNode.fromJSON(schema, adfResponse).content;

	const wrappers = adfResponseNodeWrappers ? [...adfResponseNodeWrappers] : [];
	while (wrappers.length > 0) {
		const wrapperName = wrappers.pop();
		if (
			wrapperName &&
			fragment.content.length === 1 &&
			fragment.content[0].type.name === wrapperName
		) {
			fragment = fragment.content[0].content;
		} else {
			break;
		}
	}

	return fragment;
};
